const SKIP = new Set(
  "WHY IS A AN THE WHAT HOW DOES DO TO OF AND OR ON IN IT ME MY YOU YOUR FOR WITH ABOUT SIGNAL SIGNALS LIVE ASSISTANT STRONG WEAK NOW THIS THAT ARE CAN WAS WERE BE JUST FROM INTO OVER UNDER WHEN WHERE WHICH WHO WILL WOULD SHOULD COULD TELL EXPLAIN MEAN MEANS SIDE SIDES TWO BOTH AGREE DISAGREE BOARD CARD CALL CALLS COIN COINS PRICE STOP TARGET SIZE LEVERAGE TRADE TRADING SWING SCALP HOLD BUY SELL POWERFUL USDT USD LONG SHORT TERM MID NEXT MONTH MONTHS YEAR YEARS WEEK WEEKS COMPARE ACROSS BEST ONLY CHAIN SOCIAL TECHNICAL INDICATOR INDICATORS FOREX STOCK ASX CRYPTO MODE MODES MARKET MARKETS SUGGESTION SUGGEST AGAIN CHECK GIVE PLEASE WANT NEED SHOW LOOK STANDS OUT MORE SOME HELP HERE THERE THEN THAN ALSO LIKE GOOD PLAN ALLOCATE BOOK MOSTLY SINCE WHILE THESE THOSE THEM THEY THEIR ASK READ AGO MAKE AI OK NOT ALL ONE NEW OLD USE GET SET TOP".split(
    " ",
  ),
);

const ALIAS = {
  BITCOIN: "BTC",
  ETHEREUM: "ETH",
  SOLANA: "SOL",
  BINANCE: "BNB",
  RIPPLE: "XRP",
  CARDANO: "ADA",
  DOGECOIN: "DOGE",
  AVALANCHE: "AVAX",
  POLKADOT: "DOT",
  CHAINLINK: "LINK",
  LITECOIN: "LTC",
};

const TICKERS = new Set(
  "BTC ETH SOL BNB XRP ADA DOGE AVAX DOT LINK LTC TRX ZEC PAXG RENDER XAUT PEPE SUI TON UNI AAVE NEAR ATOM FIL APT ARB OP INJ".split(
    " ",
  ),
);

export function coinsInQuestion(question) {
  const raw = String(question || "");
  const shouted = new Set(raw.match(/\b[A-Z]{2,6}\b/g) || []);
  const found = [];
  const matches = raw.toUpperCase().match(/\b[A-Z0-9]{2,10}\b/g) || [];
  matches.forEach((token) => {
    const coin = ALIAS[token] || token;
    if (SKIP.has(token) || SKIP.has(coin)) return;
    const known = Boolean(ALIAS[token]) || TICKERS.has(coin);
    const typedAsTicker = shouted.has(token);
    if (!known && !typedAsTicker) return;
    if (!found.includes(coin)) found.push(coin);
  });
  return found;
}

export function questionScope(question) {
  const text = String(question || "").toLowerCase();
  const modes = [];
  if (/\bon[- ]?chain\b/.test(text)) modes.push("only_onchain");
  if (/\bsocial\b/.test(text)) modes.push("only_social");
  if (/\b(technical|indicators)\b/.test(text)) modes.push("only_ta");
  const withoutNamedAi = text.replace(/\bai assistant\b/g, " ").replace(/\blive ai\b/g, " ");
  if (/\bai\b/.test(withoutNamedAi)) modes.push("only_ai");
  const markets = [];
  if (/\bforex\b/.test(text)) markets.push("forex");
  if (/\b(stock|stocks|asx|shares)\b/.test(text)) markets.push("asx");
  if (/\bcrypto\b/.test(text)) markets.push("crypto");
  const general = /\b(which|what coin|should i|months|month|year|years|best|hold|compare|across)\b/.test(
    text,
  );
  const longHold = /\b(month|months|year|years|long-term|long term)\b/.test(text);
  return { modes, markets, general, longHold };
}

export function modeLabel(mode) {
  if (mode === "only_ai") return "AI";
  if (mode === "only_onchain") return "On Chain";
  if (mode === "only_social") return "Social";
  if (mode === "only_ta") return "Technical Indicators";
  return "All Categories";
}

export function marketLabel(market) {
  if (market === "forex") return "forex";
  if (market === "asx") return "stock";
  return "crypto";
}

export function extraReads(question, openMarket, openMode) {
  const scope = questionScope(question);
  const market = openMarket || "crypto";
  const current = openMode && openMode !== "null" ? openMode : "default";
  const reads = [];
  const seen = new Set();
  const add = (nextMarket, mode) => {
    const key = `${nextMarket}:${mode}`;
    if (seen.has(key)) return;
    if (nextMarket === market && (mode === current || (mode === "default" && current === "default"))) return;
    seen.add(key);
    reads.push({
      market: nextMarket,
      mode,
      label: `${marketLabel(nextMarket)} ${modeLabel(mode)}`,
    });
  };
  if (scope.modes.length) {
    scope.modes.forEach((mode) => add(market, mode));
  } else if (scope.general) {
    ["only_ai", "only_onchain"].forEach((mode) => add(market, mode));
  }
  scope.markets
    .filter((item) => item !== market)
    .forEach((item) => add(item, "default"));
  return reads;
}

export function otherMarketLines(question, openMarket, page) {
  const market = openMarket || "crypto";
  return questionScope(question).markets
    .filter((item) => item !== market)
    .map((item) =>
      page === "insight"
        ? `The open Insights pack is ${marketLabel(market)}. ${marketLabel(item)} is not the pack on this screen.`
        : `The open board is ${marketLabel(market)}. ${marketLabel(item)} is a different market.`,
    );
}

export function clampPanel(width, height, viewport) {
  const viewWidth = Number(viewport?.innerWidth || viewport?.width) || 360;
  const viewHeight = Number(viewport?.innerHeight || viewport?.height) || 520;
  const maxWidth = Math.max(280, viewWidth - 48);
  const maxHeight = Math.max(320, viewHeight - 180);
  return {
    width: Math.min(maxWidth, Math.max(Math.min(480, maxWidth), width)),
    height: Math.min(maxHeight, Math.max(Math.min(640, maxHeight), height)),
  };
}

export function pageKind(pathname) {
  return String(pathname || "").toLowerCase().includes("insight") ? "insight" : "assistant";
}

export function publicAnswer(board) {
  if (!board || typeof board !== "object") {
    return "Ask about a coin on the open board.";
  }
  if (board.page === "insight") {
    const mix = board.mix || {};
    const market = marketLabel(board.market);
    const names = (board.coins || [])
      .slice(0, 3)
      .map((coin) => `${coin.symbol} ${coin.side}`)
      .join(", ");
    let text = `This Insights pack is ${market}. Indicator votes are ${mix.buy || 0} Buy, ${mix.sell || 0} Sell, and ${mix.hold || 0} Hold.`;
    if (names) text += ` Examples: ${names}.`;
    (board.misses || []).forEach((miss) => {
      text += ` ${miss}`;
    });
    return text;
  }
  const mix = board.mix || {};
  const coins = Array.isArray(board.coins) ? board.coins : [];
  const buys = coins.filter((coin) => coin.side === "Buy").slice(0, 3);
  const sells = coins.filter((coin) => coin.side === "Sell").slice(0, 3);
  let text = `On this ${marketLabel(board.market)} ${modeLabel(board.mode)} board there are ${mix.buy || 0} Buy, ${mix.sell || 0} Sell, and ${mix.hold || 0} Hold.`;
  if (board.longHold && !board.longLoaded) {
    text +=
      " The daily and weekly pivot checks are not loaded, so a longer hold follows the category call. A 15-minute or 1-hour pivot is a shorter turn, not the assistant.";
  }
  if (buys.length) {
    text += ` The board marks ${buys.map((coin) => coin.symbol).join(", ")} as Buy.`;
  }
  if (board.longHold && sells.length) {
    text += ` It is not offering ${sells.map((coin) => coin.symbol).join(", ")} for that longer hold.`;
  }
  (board.comparisons || []).forEach((item) => {
    const itemMix = item.mix || {};
    text += ` ${item.label}: ${itemMix.buy || 0} Buy, ${itemMix.sell || 0} Sell, ${itemMix.hold || 0} Hold.`;
  });
  (board.misses || []).forEach((miss) => {
    text += ` ${miss}`;
  });
  return text;
}
